import { useState, useEffect } from "react";
import LogUtils from "../utils/LogUtils";

export function useGeoLocation() {
  const TAG = "useGeoLocation";

  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [error, setError] = useState(null);

  const logUtils = new LogUtils();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setError(null);
        },
        (error) => {
          logUtils.logErrorMsg(TAG, "Não foi possível obter a geolocalização", error);
          setError(error);
        }
      );
    } else {
      logUtils.logErrorMsg(TAG, "Não foi possível obter a geolocalização", error);
      setError("Seu browser não tem suporte à geolocalização.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [ latitude, longitude, error ];
}
